import users from './users'
import suppliersNavigation from './suppliers'

export const navigation = modules => ({
  // ...modules
  ...suppliersNavigation(modules, users)
})



// WEBPACK FOOTER //
// ./src/core/legacy-auth/navigation.js